import { useEffect } from "react";
import { Routes, Route, useNavigationType, useLocation } from "react-router-dom";
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';  // Import your theme

import Landing from "./pages/Landing/Landing";
import CreatorPage from "./pages/CreatorPage/CreatorPage";
import NFTBuy from "./pages/NFTBuy/NFTBuy";
import Buy from "./pages/Buy/Buy";
import DashboardLayout from "./pages/DashboardLayout/DashboardLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardListings from "./pages/DashboardListings/DashboardListings";
import DashboardPurchases from "./pages/DashboardPurchases/DashboardPurchases";
import DashboardPayouts from "./pages/DashboardPayouts/DashboardPayouts";
import ProfileSetting from "./pages/ProfileSetting/ProfileSetting";
import HelpCenter from "./pages/HelpCenter/HelpCenter";
import HelpCenterBase from "./pages/HelpCenterBase/HelpCenterBase";
import CreateMemory from "./pages/CreateMemory/CreateMemory";
import ProtectedRoute from "./components/ProtectedRoute";
import BuyRedirect from "./pages/BuyRedirect/BuyRedirect";
import MemoryView from "./pages/MemoryView/MemoryView";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Discover the ultimate platform for creators and collectors. Share moments, create NFTs, and engage with fans like never before.";
        break;
      case "/creator-page":
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Dive into the world of top creators and their exclusive NFTs. Discover unique moments and support your favorite artists.";
        break;
      case "/nft-details":
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Get detailed insights into unique NFTs. View descriptions, sales data, and more on MomentoMaster.";
        break;
      case "/dashboard":
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Track your performance, view sales history, and manage your collections all in one place.";
        break;
      case "/marketplace":
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Browse and collect exclusive NFTs from various creators. Find the next big thing on MomentoMaster.";
        break;
      default:
        title = "MomentoMaster - Where Moments Become Memories";
        metaDescription = "Transform moments into lasting memories with MomentoMaster. Join a community of creators and collectors.";
        break;
    }

    if (title) document.title = title;
    if (metaDescription) {
      let metaDescriptionTag = document.querySelector('meta[name="description"]');
      if (!metaDescriptionTag) {
        metaDescriptionTag = document.createElement('meta');
        metaDescriptionTag.name = 'description';
        document.head.appendChild(metaDescriptionTag);
      }
      metaDescriptionTag.content = metaDescription;
    }
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Ensures consistent styling */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/creator/:descriptor" element={<CreatorPage />} />
        <Route path="/nft-buy/:descriptor" element={<NFTBuy />} />
        <Route path="/nft/:uuid" element={<BuyRedirect />} />
        <Route path="/buy/:descriptor" element={<Buy />} />
        <Route path="/help" element={<HelpCenterBase />} />
        <Route path="/help/:category" element={<HelpCenterBase />} />
        <Route path="/help/:category/:article" element={<HelpCenterBase />} />

        <Route path="/create" element={
          <ProtectedRoute>
            <CreateMemory />
          </ProtectedRoute>
        } />
        
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} /> 
          <Route path="listings" element={<DashboardListings />} />
          <Route path="purchased" element={<DashboardPurchases />} />
          <Route path="finances" element={<DashboardPayouts />} />
          <Route path="account-details" element={<ProfileSetting />} />
          <Route path="help" element={<HelpCenter />} />
          <Route path="help/:category" element={<HelpCenter />} />
          <Route path="help/:category/:article" element={<HelpCenter />} />
          <Route path="memory/:descriptor" element={<MemoryView />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;